
import AboutMe from './pages/AboutMe'
import Portfolio from './pages/Portfolio'

const routes = [
	{ 
		path: '/',
		meta: {
			title: 'Cheng Vue',
		},
		component: AboutMe
	},
	{
		path: '/portfolio',
		meta: {
			title: 'Cheng Vue - Portfolio',
		},
		component: Portfolio
	},
]

export default routes;